<template>
  <base-layout :title="title" :backLink="backLink" :reloadable="reloadable">
    <ion-refresher slot="fixed" @ionRefresh="refresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <bill-fee :resources="resources"></bill-fee>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-infinite-scroll threshold="100px" @ionInfinite="loadData($event)">
      <ion-infinite-scroll-content
        loading-spinner="bubbles"
        loading-text="Loading more data..."
      >
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
    <!-- <ion-fab vertical="bottom" horizontal="end" slot="fixed" edge>
      <ion-fab-button @click="setCreateModalState(true)">
        <ion-icon :ios="addOutline" :md="addOutline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-modal
      :is-open="createModalState"
      @didDismiss="setCreateModalState(false)"
    >
      <base-modal
        title="Add student to class"
        @closeModal="setCreateModalState(false)"
      >
        <create-bill-fee
          :resource="resources.data.sectionStandard"
          @closeModal="setCreateModalState(false)"
        ></create-bill-fee>
      </base-modal>
    </ion-modal> -->
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout";
// import BaseModal from "../../Base/BaseModal";
import BillFee from "../../Components/Due/Bill/BillFee.vue";

import {
  IonGrid,
  IonRow,
  IonCol,
//   IonFab,
//   IonIcon,
//   IonFabButton,
//   IonModal,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonRefresher,
  IonRefresherContent,
} from "@ionic/vue";

// import { addOutline } from "ionicons/icons";

export default {
  props: ["bill"],

  components: {
    BaseLayout,
    // BaseModal,
    // CreateBillFee,
    BillFee,
    IonGrid,
    IonRow,
    IonCol,
    // IonFab,
    // IonIcon,
    // IonFabButton,
    // IonModal,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonRefresher,
    IonRefresherContent,
  },

  data() {
    return {
      title: "Fees",
      backLink: "bill",
      reloadable: true,

    //   createModalState: false,

    //   addOutline,
    };
  },

  computed: {
    resources() {
      return this.$store.getters["billShow/resources"];
    },
    shouldReload() {
      return this.$store.getters["reload"] === this.$route.name;
    },
  },

  watch: {
    shouldReload(current) {
      if (current) {
        this.refresh();
        this.$store.dispatch("clearReload");
      }
    },
  },

  methods: {
    async sync() {
      const title = this.$store.getters["billShow/title"];
      this.title = title;
    },
    async fetch(refresh = false) {
      await this.$store.dispatch("billShow/resources", {
        resourceId: this.bill,
        refresh: refresh,
      });
      this.sync();
    },
    loadData(event) {
      this.fetch();
      event.target.complete();
    },
    async refresh(event) {
      await this.$store.dispatch("billShow/resources", {
        resourceId: this.bill,
        refresh: true,
      });
      if (event) {
        event.target.complete();
      }
      this.sync();
    },
    setCreateModalState(state) {
      this.createModalState = state;
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style scoped>
</style>
